<template>
  <el-dialog
    :title="title"
    :visible.sync="tripdialogClient"
    width="80%"
    top="5vh"
    :before-close="doClose"
    :modal-append-to-body="false"
  >
    <el-form ref="serviceform" :model="serviceform" label-width="150px">
      <el-row :gutter="24">
        <el-col :xs="24" :sm="24">
          <el-form-item label="监控指标" style="margin-top: 0">
            <el-select
              multiple
              filterable
              collapse-tags
              :placeholder="$t('title.selectFive')"
              v-model="serviceform.value"
              :multiple-limit="5"
              style="width: 100%"
              @change="changeCcnGather"
            >
              <el-option
                v-for="item in gatherOption"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      class="echarts"
      id="KchartDiv"
      style="height: 350px; margin-top: 15px"
    ></div>
  </el-dialog>
</template>

<script>
import { getTripWarningMonitor } from "../../../api/api";
export default {
  name: "index",
  props: {
    tripdialogClient: false,
    title: "",
    alarmId:"",
    // serviceform: {},
  },
  watch: {
    tripdialogClient: {
      async handler(newValue, oldValue) {
        if (newValue === true) {
          let that = this;
          await this.getTripWarningMonitor();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      serviceform: {},
      gatherOption: {},
      viewData:{},
    };
  },
  methods: {
    doClose() {
      this.$emit("dialogVisibleEvent", false);
    },
    async getTripWarningMonitor(){
      let that = this;
      let res = await getTripWarningMonitor(that.alarmId);
      this.viewData = res.result;
      if (!res.result){
        return false;
      }
      that.gatherOption = this.viewData.codeList;
      that.serviceform.value = that.gatherOption.slice(0,5)
      await this.changeCcnGather();
    },
    changeCcnGather(){
      let that = this;
      const codeList = that.serviceform.value;
      let chartDataList = this.viewData.chartDataList.filter(x=>codeList.some(a=>a==x.code)).map(x=>x.dataList);
      let dataNameList = this.viewData.chartDataList.filter(x=>codeList.some(a=>a==x.code)).map(x=>x.code);
      let dateList = this.viewData.dateTimeList;
      that.$nextTick(() => {
        that.InitTripLine(chartDataList, dataNameList, dateList);
      });
    },
    InitTripLine(chartDataList,dataNameList,dateList) {
      let kchart = this.$echarts.init(document.getElementById("KchartDiv"));

      var Linecolor = ["#28739A", "#55B478", "#27508B", "#FFDE76", "#369089"];
      var Linecolor2 = [
        "rgba(0,117,155,0.05)",
        "rgba(0,182,125,0.05)",
        "rgba(3,81,139,0.05)",
        "rgba(255,222,118,0.05)",
        "rgba(54,144,137,0.05)",
      ];

      var chartDataList = chartDataList;
      var dateTimeList = dateList;

      let DataName = dataNameList;

      var seriesList = [];

      for (var i = 0; i < DataName.length; i++) {
        var temp = {
          name: DataName[i],
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          itemStyle: {
            borderColor: Linecolor[i],
            color: Linecolor[i],
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: Linecolor[i] },
                { offset: 1, color: Linecolor2[i] },
              ]),
            },
          },
          data: chartDataList[i],
        };
        seriesList.push(temp);
      }

      var optionK = {
        legend: {
          data: DataName,
          textStyle: {
            color: "#828393",
            align: "left",
          },
          left: 0,
          top: 0,
          itemWidth: 16,
          itemHeight: 6,
          icon: "roundRect",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 150];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 60,
          left: 40,
          right: 40,
          bottom: 80,
        },
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: dateTimeList,
          },
        ],
        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: seriesList,
      };

      kchart.setOption(optionK,true);

      window.addEventListener("resize", () => {
        kchart.resize();
      });
    },
  },
  created() {
    // var that = this;
    // this.$nextTick(() => {
    //   that.InitTripLine;
    // });
  },
};
</script>
 